import { Instagram, Mail, Music2 } from "lucide-react";
import { UI, CONTACT_INFO } from "@/data/content";

const Row = ({ testid, href, icon: Icon, label, value }) => (
  <a
    data-testid={testid}
    href={href}
    target={href.startsWith("http") ? "_blank" : undefined}
    rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
    className="group flex items-center gap-5 px-2 sm:px-4 py-6 transition-colors duration-300 hover:bg-[#7E2438]/10"
  >
    <span className="w-11 h-11 shrink-0 rounded-full border border-[#7E2438]/40 flex items-center justify-center text-[#B03A52] transition-colors duration-300 group-hover:bg-[#7E2438] group-hover:text-[#F4EFEA]">
      <Icon size={17} />
    </span>
    <span className="font-serif text-lg sm:text-2xl text-[#F4EFEA] transition-colors duration-300 group-hover:text-[#B03A52] break-all">
      {value}
    </span>
    {label && (
      <span className="ml-auto font-mono text-[11px] tracking-[0.2em] uppercase text-[#A89A9E] shrink-0">{label}</span>
    )}
  </a>
);

export default function Contact({ lang }) {
  const t = UI[lang];
  return (
    <section id="contact" data-testid="contact-section" className="relative px-6 sm:px-12 md:px-20 py-28 border-t border-[#7E2438]/25">
      <span className="font-mono text-xs tracking-[0.3em] uppercase text-[#B03A52]">{t.contactEyebrow}</span>
      <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl tracking-tight font-serif text-[#F4EFEA]">{t.contactTitle}</h2>
      <p className="mt-4 max-w-xl text-base sm:text-lg leading-relaxed text-[#A89A9E]">{t.contactText}</p>
      <div className="mt-12 max-w-2xl border-y border-[#7E2438]/25 divide-y divide-[#7E2438]/25">
        <Row testid="contact-email" href={`mailto:${CONTACT_INFO.email}`} icon={Mail} value={CONTACT_INFO.email} />
        <Row testid="contact-instagram" href={CONTACT_INFO.instagram} icon={Instagram} label="Instagram" value="@pia.dolesch" />
        <Row testid="contact-tiktok" href={CONTACT_INFO.tiktok} icon={Music2} label="TikTok" value="@pia.dolesch" />
      </div>
    </section>
  );
}
